import React, { useEffect, useState } from 'react';

interface AnimatedWordProps {
  words: string[];
  interval?: number;
  className?: string;
}

export function AnimatedWord({ 
  words, 
  interval = 2500,
  className = '' 
}: AnimatedWordProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const longestWord = words.reduce((a, b) => a.length > b.length ? a : b);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % words.length);
    }, interval);

    return () => clearInterval(timer);
  }, [words.length, interval]);

  return (
    <span className="inline-block relative">
      {words.map((word, index) => (
        <span
          key={word}
          className={`absolute inset-0 transition-all duration-700 ease-in-out ${className} ${
            currentIndex === index
              ? 'opacity-100 translate-y-0'
              : index === (currentIndex - 1 + words.length) % words.length
              ? 'opacity-0 -translate-y-2'
              : 'opacity-0 translate-y-2'
          }`}
        >
          {word}
        </span>
      ))}
      {/* Invisible placeholder to maintain layout space */}
      <span className={`opacity-0 pointer-events-none ${className}`}>
        {longestWord}
      </span>
    </span>
  );
}
